// Frontend config - uses import.meta.env for Vite
// All API calls go through local backend proxy, so no external URLs needed here

// Load Test Config defaults. The dedicated load-test classroom is rostered with
// students that all share `password`; usernames and the lesson are derived from
// the classroom on the backend, so neither is configured here.
//
// `classroom_name` matches the classroom the provision script creates
// (scripts/provision-loadtest-classroom.ts, LT_CLASSROOM_NAME). The form
// pre-selects it by name since its id is auto-assigned and not stable.
export const LOAD_TEST_DEFAULTS = {
  classroom_id: 0,
  classroom_name: "Load Test Classroom",
  password: "ltpwd",
};

// Tutor version applications (TV management only — gateway has no TVs)
export const APPLICATIONS = [
  { value: "ai-tutor", label: "AI Tutor" },
  { value: "et-studio", label: "ET Studio" },
] as const;

// Prompt applications (superset — gateway prompts are managed here)
export const PROMPT_APPLICATIONS = [
  { value: "ai-tutor", label: "AI Tutor" },
  { value: "gateway", label: "Gateway" },
  { value: "et-studio", label: "ET Studio" },
] as const;

export const DEFAULT_APPLICATION_ID = "ai-tutor";

// Prompt Service Config. The browser calls prompt-config only through the
// dashboard server (src/api/routes/prompt-config.ts), which checks the tab
// grant and adds the internal key the service requires.
export const PROMPT_SERVICE_CONFIG = {
  BASE_URL: "/api/proxy/prompt-config",
  ENDPOINTS: {
    PROMPTS: "/prompts",
    PROMPT: (appId: string, promptId: string) =>
      `/prompts/${appId}/${promptId}`,
    PROMPT_VERSIONS: (appId: string, promptId: string) =>
      `/prompts/${appId}/${promptId}/versions`,
    PROMPT_VERSION_STATUSES: (appId: string, promptId: string) =>
      `/prompts/${appId}/${promptId}/version-statuses`,
    PROMPT_VERSION: (appId: string, promptId: string, version: string) =>
      `/prompts/${appId}/${promptId}/versions/${version}`,
    EXPERIMENTS: "/experiments",
    EXPERIMENT: (experimentId: string) => `/experiments/${experimentId}`,
    EXPERIMENT_START: (experimentId: string) =>
      `/experiments/${experimentId}/start`,
    EXPERIMENT_STOP: (experimentId: string) =>
      `/experiments/${experimentId}/stop`,
    TUTOR_VERSIONS: (appId: string) => `/tutor-versions/${appId}`,
    TUTOR_VERSION: (appId: string, tvId: string) =>
      `/tutor-versions/${appId}/${tvId}`,
    TUTOR_VERSION_PUBLISH: (appId: string, tvId: string) =>
      `/tutor-versions/${appId}/${tvId}/publish`,
    TUTOR_VERSION_ARCHIVE: (appId: string, tvId: string) =>
      `/tutor-versions/${appId}/${tvId}/archive`,
    TUTOR_VERSION_SET_DEFAULT: (appId: string, tvId: string) =>
      `/tutor-versions/${appId}/${tvId}/set-default`,
    TUTOR_VERSION_SET_ORG_DEFAULT: (appId: string) =>
      `/tutor-versions/${appId}/set-org-default`,
    TUTOR_VERSION_ORG_DEFAULTS: (appId: string) =>
      `/tutor-versions/${appId}/org-defaults`,
    TUTOR_VERSION_REMOVE_ORG_DEFAULT: (appId: string, org: string) =>
      `/tutor-versions/${appId}/org-default/${org}`,
    TUTOR_VERSION_EXPORT: (appId: string, tvId: string) =>
      `/tutor-versions/${appId}/${tvId}/export`,
    TUTOR_VERSION_IMPORT_BATCH: "/tutor-versions/import/batch",
  },
};
